/**
 * Swatches de color en tarjetas de producto.
 *
 * Al seleccionar un swatch la tarjeta cambia por completo a esa variante:
 * imagen, precio, enlace al producto, id del formulario de añadir al carrito
 * y disponibilidad del botón.
 *
 * Se apoya en delegación de eventos, así que también funciona con las tarjetas
 * que llegan por section rendering (filtros, paginación, quick add).
 */
(function () {
  'use strict';

  if (window.__productCardSwatchesReady) return;
  window.__productCardSwatchesReady = true;

  var SWATCH = '.product-card-swatch[data-variant-id]';
  var CARD = 'product-card, .product-card, [data-product-card]';
  var IMAGE =
    'img.product-media__image, img.resource-card__image, .card-gallery img, .product-media img';

  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  function cardOf(el) {
    return closest(el, CARD);
  }

  /* ── Imagen ──────────────────────────────────────────────────── */

  function primaryImage(card) {
    return card.querySelector(IMAGE);
  }

  function setImage(card, src, srcset) {
    var img = primaryImage(card);
    if (!img || !src) return;

    if (img.dataset.pcsBaseSrc === undefined) {
      img.dataset.pcsBaseSrc = img.getAttribute('src') || '';
      img.dataset.pcsBaseSrcset = img.getAttribute('srcset') || '';
    }

    if (srcset) {
      img.setAttribute('srcset', srcset);
    } else {
      img.removeAttribute('srcset');
    }
    img.setAttribute('src', src);
  }

  function restoreImage(card) {
    var img = primaryImage(card);
    if (!img || img.dataset.pcsBaseSrc === undefined) return;

    var selected = card.querySelector(SWATCH + '.is-selected');
    if (selected && selected.dataset.image) {
      setImage(card, selected.dataset.image, selected.dataset.imageSrcset);
      return;
    }

    if (img.dataset.pcsBaseSrcset) {
      img.setAttribute('srcset', img.dataset.pcsBaseSrcset);
    } else {
      img.removeAttribute('srcset');
    }
    img.setAttribute('src', img.dataset.pcsBaseSrc);
  }

  /* ── Precio ──────────────────────────────────────────────────── */

  function setPrice(card, price, compareAt) {
    if (!price) return;

    var scope = card.querySelector('product-price') || card;
    var priceEl = scope.querySelector('.price');
    if (priceEl && priceEl.innerHTML !== price) priceEl.innerHTML = price;

    var compareEl = scope.querySelector('.compare-at-price');
    if (!compareEl) return;

    if (compareAt) {
      compareEl.innerHTML = compareAt;
      compareEl.hidden = false;
    } else {
      compareEl.hidden = true;
    }
  }

  /* ── Enlaces y formulario ────────────────────────────────────── */

  function setVariantUrl(card, url) {
    if (!url) return;

    card.setAttribute('data-product-url', url);

    var links = card.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) links[i].setAttribute('href', url);
  }

  function setFormVariant(card, variantId, available) {
    var inputs = card.querySelectorAll('form input[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      if (variantId) inputs[i].value = variantId;
      // Liquid deshabilita el input cuando la variante inicial está agotada.
      inputs[i].disabled = !available;
    }

    var buttons = card.querySelectorAll('form button[name="add"]');
    var quickAddButton = null;

    for (var j = 0; j < buttons.length; j++) {
      var button = buttons[j];
      button.disabled = !available;

      // Botón propio de la tarjeta: es de texto, solo se le cambia la etiqueta.
      if (button.classList.contains('product-card-btn')) {
        var label = button.querySelector('span:not(.btn-loader)');
        if (!label) continue;

        if (label.dataset.pcsLabel === undefined) label.dataset.pcsLabel = label.textContent;
        label.textContent = available ? label.dataset.pcsLabel : soldOutLabel(card);
        continue;
      }

      // Botón de carrito del tema: es un icono que se expande al pasar el
      // cursor, así que su contenido no se toca. Cuando el color no tiene stock
      // se esconde y en su sitio va la etiqueta de agotado; Liquid ya lo oculta
      // si la variante inicial no se puede comprar, y al elegir un color con
      // stock se devuelve a la vista.
      if (available) {
        button.style.removeProperty('display');
      } else {
        button.style.display = 'none';
      }

      if (!quickAddButton) quickAddButton = button;
    }

    setQuickAddSoldOut(card, quickAddButton, available);
  }

  /* ── Aviso de agotado ────────────────────────────────────────── */

  function soldOutLabel(card) {
    var list = card.querySelector('.product-card-swatches');
    return (list && list.dataset.soldOutLabel) || 'Agotado';
  }

  // En el hueco del carrito: si el color elegido no tiene stock se esconden los
  // botones de añadir y en su sitio queda una sola etiqueta "Agotado". Al
  // elegir un color con stock se retira la etiqueta y vuelven los botones.
  function setQuickAddSoldOut(card, addButton, available) {
    var label = card.querySelector('.product-card-sold-out-label');

    if (available) {
      if (label && label.parentNode) {
        var parent = label.parentNode;
        parent.removeChild(label);
        if (parent.classList) parent.classList.remove('quick-add--sold-out');
      }
      return;
    }

    // Si Liquid ya pintó la etiqueta (producto o variante inicial agotados) se
    // deja como está.
    if (label || !addButton) return;

    // El contenedor del quick-add alinea abajo a la derecha; si no existe, se
    // coloca junto al botón que se acaba de esconder.
    var host = closest(addButton, '.quick-add') || addButton.parentNode;
    if (!host) return;

    label = document.createElement('span');
    label.className = 'product-card-sold-out-label';
    label.setAttribute('data-pcs-sold-out', '');
    label.textContent = soldOutLabel(card);
    host.appendChild(label);
    if (host.classList) host.classList.add('quick-add--sold-out');
  }

  /* ── Selección ───────────────────────────────────────────────── */

  function select(swatch, options) {
    var card = cardOf(swatch);
    if (!card) return;

    var list = closest(swatch, '.product-card-swatches__list') || card;
    var siblings = list.querySelectorAll(SWATCH);
    for (var i = 0; i < siblings.length; i++) {
      var isCurrent = siblings[i] === swatch;
      siblings[i].classList.toggle('is-selected', isCurrent);
      siblings[i].setAttribute('aria-pressed', String(isCurrent));
    }

    var data = swatch.dataset;
    var available = data.available !== 'false';

    setFormVariant(card, data.variantId, available);
    setVariantUrl(card, data.variantUrl);
    setPrice(card, data.price, data.compareAtPrice);

    if (!options || options.updateImage !== false) {
      setImage(card, data.image, data.imageSrcset);
    }

    card.dispatchEvent(
      new CustomEvent('product-card:variant-change', {
        bubbles: true,
        detail: { variantId: data.variantId, available: available }
      })
    );
  }

  /* ── Eventos ─────────────────────────────────────────────────── */

  document.addEventListener('click', function (event) {
    var swatch = closest(event.target, SWATCH);
    if (!swatch) return;

    // La tarjeta navega al producto al hacer clic en cualquier zona neutra.
    event.preventDefault();
    event.stopPropagation();

    select(swatch);
  });

  document.addEventListener(
    'mouseover',
    function (event) {
      var swatch = closest(event.target, SWATCH);
      if (!swatch || swatch.classList.contains('is-selected')) return;

      var card = cardOf(swatch);
      if (card && swatch.dataset.image) {
        setImage(card, swatch.dataset.image, swatch.dataset.imageSrcset);
      }
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      var swatch = closest(event.target, SWATCH);
      if (!swatch) return;

      var related = event.relatedTarget;
      if (related && closest(related, SWATCH) === swatch) return;

      var card = cardOf(swatch);
      if (card) restoreImage(card);
    },
    true
  );

  /* ── Estado inicial ──────────────────────────────────────────── */

  function syncInitialState(root) {
    var selected = (root || document).querySelectorAll(SWATCH + '.is-selected');

    for (var i = 0; i < selected.length; i++) {
      // La imagen ya viene renderizada por Liquid; solo se alinean
      // formulario, enlaces y precio con el swatch marcado.
      //
      // Excepción: cuando Liquid marca otro color porque el de la imagen
      // destacada está agotado (data-sync-image), la imagen sí se actualiza
      // para que coincida con el color seleccionado.
      var syncImage = selected[i].dataset.syncImage === 'true';
      select(selected[i], { updateImage: syncImage });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncInitialState(document);
    });
  } else {
    syncInitialState(document);
  }

  // Tarjetas que llegan después (filtros, paginación, section rendering).
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;

        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches(CARD) || node.querySelector(SWATCH)) syncInitialState(node);
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
